import { gaClickTrack } from "helpers/ga_event_tracking";
import { ChangeEvent, useState } from "react";
import { MdThumbDown, MdThumbUp } from "react-icons/md";
import SVG from "react-inlinesvg";

import DownArrow from "@assets/icons/down.svg";

import { CommunityMemberAvatar } from "@/client_app/components/CommunityMemberAvatar";
import { FeedbackModal } from "@/client_app/features/timesheetApproval/components/FeedbackModal";
import { CheckboxWithIndeterminateState } from "@/ui/CheckboxWithIndeterminateState";

interface SubmittedAttendancesGroupProfileProps {
  positionTitle: string;
  positionId: string;
  profileImageUrl: string;
  fullName: string;
  totalHoursWorked: string;
  attendanceCount: number;
  isExpanded: boolean;
  showRatingFeedback: boolean;
  isMobile: boolean;
  onExpandList: (event: React.MouseEvent) => void;
  selectAllToggle: () => void;
  selectedAttendanceCount: number;
}

export const SubmittedAttendancesGroupProfile = ({
  positionTitle,
  positionId,
  profileImageUrl,
  fullName,
  totalHoursWorked,
  attendanceCount,
  showRatingFeedback,
  isExpanded,
  isMobile,
  onExpandList,
  selectAllToggle,
  selectedAttendanceCount,
}: SubmittedAttendancesGroupProfileProps): JSX.Element => {
  let checkboxState;
  if (selectedAttendanceCount === attendanceCount) {
    checkboxState = "CHECKED";
  } else if (selectedAttendanceCount > 0) {
    checkboxState = "INDETERMINATE";
  } else {
    checkboxState = "EMPTY";
  }

  const [openModal, setOpenModal] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  function gaEventTracking(event: ChangeEvent) {
    const target: HTMLInputElement = event.target as HTMLInputElement;
    gaClickTrack({
      checkbox_label: "Select Individual Submitted Weployees",
      checkbox_name: "selectIndividualSubmittedWeployees",
      checked: target.checked.toString(),
    });
  }

  function handleChange(event: ChangeEvent) {
    gaEventTracking(event);
    selectAllToggle();
  }

  return (
    <div className='flex items-start col-span-full md:col-span-2'>
      <div className='flex items-start md:items-center'>
        <div className='mr-3.5'>
          <CheckboxWithIndeterminateState
            state={checkboxState}
            onChange={handleChange}
          />
        </div>
        <CommunityMemberAvatar
          profileImageUrl={profileImageUrl}
          name={fullName}
          size='SMALL'
        />
      </div>
      <div className='ml-3 p2 md:p3'>
        <div className='font-semibold mb-1'>
          {fullName} ({attendanceCount})
        </div>
        <div className='mb-1'>{positionTitle}</div>
        <div className='text-neutral-600 mb-1'>
          Total Hours Worked: {totalHoursWorked}
        </div>
        {!isSubmitted && showRatingFeedback && (
          <div className='flex gap-2 pt-2 client_rating_feedback'>
            {openModal && (
              <FeedbackModal
                isLiked={isLiked}
                closeModal={() => setOpenModal(false)}
                profileImageUrl={profileImageUrl}
                fullName={fullName}
                positionId={positionId}
                submitted={() => setIsSubmitted(true)}
              />
            )}

            <MdThumbUp
              className='cursor-pointer bg-gray-100 rounded-full h-10 w-10 p-2 text-primary-800'
              onClick={() => {
                setIsLiked(true);
                setOpenModal(true);
              }}
            />
            <MdThumbDown
              className='cursor-pointer bg-gray-100 rounded-full h-10 w-10 p-2 text-error-400'
              onClick={() => {
                setIsLiked(false);
                setOpenModal(true);
              }}
            />
          </div>
        )}
        {isMobile && attendanceCount > 1 && (
          <div>
            <button className='font-semibold mb-2' onClick={onExpandList}>
              <span className='flex items-center'>
                {isExpanded ? "VIEW LESS" : "VIEW ALL SHIFTS"}
                <SVG
                  src={DownArrow}
                  className='icon fill-current mr-4 cursor-pointer'
                />
              </span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
